/* eslint-disable sonarjs/no-all-duplicated-branches */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Collapse, message } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { SalesmanRejectCollection } from './index';
import { Box } from 'atoms';
import {
	clearCheckList,
	final_submit,
	getSalesInvoicesList,
	setAdditionalFilter,
	setIsAccordionOpen,
	setPanelKey,
	submitPendingInvoice,
} from 'store/salesmanSlice';
import { useQueryParams } from 'hooks';
import { Shimmer, NoData } from 'components';
import { AR } from 'utils/constants';
import SalesmanMyCollection from './SalesmanMyCollection';
import AccordionHeaderSalesman from 'components/Salesman-common/AccordionHeaderSalesman';
import InvoiceSearch from 'components/pages/collection-app/InvoiceSearch';
import { setNotifications } from 'store/salesmanNotiySlice';
import DashInfo from './DashInfo';
import SalesmanHeader from './SalesmanHeader';
import ConfimationBeforeSubmit from './ConfimationBeforeSubmit';

const { Panel } = Collapse;

const Container = styled(Box)`
	background-color: ${(props) => props.theme.colors.Cultured};
	height: 100%;
`;

const FinBtn = styled(Button)`
	position: fixed;
	bottom: 0px;
	width: 100%;
	height: 40px;
	background: #1890ff;
	color: #000;
	margin-left: -9px;
`;

const MobileContainer = styled(Box)`
	height: calc(100% - 182px);
	border: 1px solid #d9d9d9;
	position: relative;
`;

export default function SalesmanDashboard() {
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();

	const span = document.querySelector('#root');
	const width = span.offsetWidth;

	const {
		SalesInvoices = [],
		SalesInvoicesFiltered = [],
		SalesRejectedInvoices = [],
		SalesRejectedInvoicesFiltered = [],
		additionalFilter,
		isAccordionOpen,
		panelKey,
		can_salesman_edit,
	} = useSelector((state) => state.salesman);
	const [showShimmer, setShowShimmer] = useState(true);
	const { salesmanId = undefined } = useQueryParams();
	const { me = {} } = useSelector((state) => state.user);
	const { invoiceDate } = useSelector((state) => state.app);
	const [checkthecount, setCheckthecount] = useState(0);
	const [checkRejectthecount, setRejjectCheckthecount] = useState(0);
	const [checktheDefaulcount, setCheckDefauthecount] = useState(0);
	const [checkRejectDefauthecount, setRejjectCheckDefauthecount] = useState(0);
	const [unblock, setUnblock] = useState(false);
	const [confimationBtn, setConfimationBtn] = useState(false);
	const [sales_man_id, Setsales_man_id] = useState('');
	const [hasPendingCollections, setHasPendingCollections] = useState(false);

	useEffect(() => {
		if (salesmanId) {
			Setsales_man_id(salesmanId);
		} else {
			Setsales_man_id(me?.id);
		}
	}, [salesmanId, me?.id]);

	useEffect(() => {
		dispatch(setIsAccordionOpen(false));

		if (SalesRejectedInvoices.length > 0) {
			dispatch(setPanelKey(['2']));
		} else {
			dispatch(setPanelKey(['1']));
		}
	}, [SalesRejectedInvoices.length, dispatch]);

	if (additionalFilter) {
		dispatch(setAdditionalFilter(false));
	}

	useEffect(() => {
		dispatch(getSalesInvoicesList(salesmanId));
		setTimeout(() => {
			setShowShimmer(false);
		}, 3000);
	}, [salesmanId, dispatch, me?.type, invoiceDate]);

	// eslint-disable-next-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (SalesInvoices?.length > 0) {
			setCheckthecount(
				SalesInvoices?.filter((item) => ['SUBMIT'].includes(item?.action)).length
			);
			setCheckDefauthecount(
				SalesInvoices?.filter((item) =>
					['DEFAULT', undefined, null, ''].includes(item?.action)
				).length
			);
		}
	}, [SalesInvoices, checkthecount]);

	useEffect(() => {
		if (SalesRejectedInvoices?.length > 0) {
			setRejjectCheckthecount(
				SalesRejectedInvoices?.filter((item) => ['SUBMIT'].includes(item?.action)).length
			);
			setRejjectCheckDefauthecount(
				SalesRejectedInvoices?.filter((item) =>
					['DEFAULT', undefined, null, ''].includes(item?.action)
				).length
			);
		}
	}, [SalesRejectedInvoices, checkthecount]);

	useEffect(() => {
		// clear checkbox current state
		dispatch(clearCheckList());

		// clear notifications
		dispatch(setNotifications([]));

		// dispatch(getNotifications(salesmanId));
	}, [dispatch, me?.type, salesmanId]);

	// Calculate pending collections status
	useEffect(() => {
		const pendingCount = SalesInvoices.filter((item) => item.status === 'Pending').length;

		setHasPendingCollections(pendingCount > 0);
	}, [SalesInvoices]);

	useEffect(() => {
		/**
		 * On Additional resource login, in collection page if salesmanId id
		 * not available then redirect to salesmen list page
		 */
		if (me?.type === AR && !salesmanId) {
			history.push('sales-men');
		}
	}, [me?.type, salesmanId, history, location]);

	const accordionStatus = (e) => {
		dispatch(setIsAccordionOpen(!isAccordionOpen));
		dispatch(setPanelKey(e));
	};

	const checkDisabled = (checkvalue) => {
		if (checkvalue) {
			return true;
		}
		if (can_salesman_edit === false) {
			return true;
		}
		if (checktheDefaulcount > 0 || checkRejectDefauthecount > 0) {
			return false;
		}
		if (checkthecount > 0 || checkRejectthecount > 0) {
			return true;
		}

		return false;
	};

	const handleFinalSubmit = () => {
		setUnblock(false);

		if (!checkDisabled(false)) {
			setConfimationBtn(true);
		}
	};

	const handleUpdateCancel = () => {
		setConfimationBtn(false);
	};

	const handleUpdateOk = (showMessage = false) => {
		console.log(salesmanId, invoiceDate);

		const stores_id = SalesRejectedInvoices.map((item) => item.store_id);

		checkDisabled(true);

		if (SalesRejectedInvoicesFiltered?.length > 0) {
			dispatch(submitPendingInvoice(invoiceDate, sales_man_id, stores_id, showMessage)).then(
				() => {
					dispatch(getSalesInvoicesList(salesmanId));
					setConfimationBtn(false);
				}
			);
		} else {
			dispatch(final_submit(sales_man_id, invoiceDate, showMessage)).then(() => {
				dispatch(getSalesInvoicesList(sales_man_id));
				setConfimationBtn(false);
			});
		}
	};

	const checkCollectionArray = () => {
		const PendingCollectionCount = SalesInvoices.filter(
			(item) => item.status === 'Pending'
		).length;

		if (PendingCollectionCount > 0) {
			message.error('Please select  Bill Back reason for pending invoices before you submit');

			return false;
		}

		return true;
	};

	return (
		<Container>
			<SalesmanHeader isPending={hasPendingCollections} />
			<DashInfo />
			{SalesInvoices?.length > 0 && <InvoiceSearch />}

			{showShimmer ? (
				<Shimmer />
			) : (
				<MobileContainer mx={2} mt={2} className="collapse__card">
					<Collapse
						style={{ background: 'none' }}
						activeKey={panelKey}
						onChange={accordionStatus}
					>
						{/* My Collections */}
						{SalesRejectedInvoicesFiltered?.length > 0 && (
							<Panel
								key="2"
								className="rejected"
								header={
									<AccordionHeaderSalesman
										title="Rejected"
										invoiceCount={SalesRejectedInvoicesFiltered?.length}
									/>
								}
							>
								<SalesmanRejectCollection />
							</Panel>
						)}
						<Panel
							key="1"
							header={
								<AccordionHeaderSalesman
									title="My Collections"
									invoiceCount={SalesInvoicesFiltered?.length}
								/>
							}
						>
							<SalesmanMyCollection />
						</Panel>
					</Collapse>

					<FinBtn
						style={{
							width: width > 0 ? width : 500,
							backgroundColor: checkDisabled(false) ? '#cbe6ff' : '#1890ff',
							color: checkDisabled(false) ? '#1890ff !important' : '#000',
							cursor: checkDisabled(false) ? 'none' : 'pointer',
						}}
						type="primary"
						onClick={() => (checkCollectionArray() ? handleFinalSubmit() : null)}
					>
						{checkDisabled(false) ? 'Submitted' : 'Submit Collection'}
					</FinBtn>
				</MobileContainer>
			)}
			<ConfimationBeforeSubmit
				visible={confimationBtn}
				unblock={unblock}
				handleOk={handleUpdateOk}
				handleCancel={handleUpdateCancel}
			/>
		</Container>
	);
}

NoData.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
